// Read receipts this client put on the wire, by scope, so a `read_broadcast` that
// carries one of them is recognised as this client's own echo (#514). The relay
// never echoes a socket's own read; the daemon broadcasts to every socket of the
// user, the sender included, and the two must be told apart the same way. Every
// receipt carries a client stamp (Date.now() at send), so equality is exact.
const KEEP = 16;

export class SentReadStamps {
  private readonly byScope = new Map<string, number[]>();

  record(scope: string, at: number): void {
    const list = this.byScope.get(scope) ?? [];
    list.push(at);
    if (list.length > KEEP) list.splice(0, list.length - KEEP);
    this.byScope.set(scope, list);
  }

  /** True when `at` is a stamp this client sent for `scope`. */
  isOwn(scope: string, at: number): boolean {
    return this.byScope.get(scope)?.includes(at) ?? false;
  }

  clear(): void {
    this.byScope.clear();
  }
}
